export function Constants() {
  angular.module('classkickApp')
    .constant('constants', {"version": "5.222.1-1800f11", "backend": "webservices", "projectId": "classkick-907"});
}
